module.exports = __webpack_public_path__ + "img/terroir-disc-4-mobile.0e4f0a1a.jpg";